import Swiper, {Navigation} from "swiper";

const productsSlider = new Swiper($('.products-slider')[0], {
    slidesPerView: 1,
    loop: true,
    touchRatio: 0.1,
    centeredSlides: true,
    navigation: {
        prevEl: $('.products-slider .swiper-button-prev')[0],
        nextEl: $('.products-slider .swiper-button-next')[0]
    },
    modules: [Navigation]
});
